// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bulk-upload-dialog {
  min-width: 500px;
  max-width: 600px;
}

.upload-container {
  padding: 20px 0;
}

.instructions {
  color: #666;
  margin-bottom: 20px;
  line-height: 1.5;
}

.template-download-section {
  margin: 15px 0;
  text-align: center;
}

.template-download-btn {
  min-width: 200px;
}

.file-upload-section {
  margin: 20px 0;
}

.file-input-wrapper {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
  transition: all 0.3s ease;
}

.file-input-wrapper:hover {
  border-color: #3f51b5;
  background-color: #f5f5f5;
}

.file-name {
  flex: 1;
  color: #333;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 10px;
}

.no-file-selected {
  color: #999;
  font-style: italic;
}

.clear-file-btn {
  width: 24px;
  height: 24px;
  line-height: 24px;
}

.clear-file-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}

.upload-progress {
  margin: 20px 0;
}

.uploading-text {
  text-align: center;
  color: #ff6f00;
  font-weight: 500;
  margin-top: 10px;
  font-size: 16px;
}

.info-section {
  display: flex;
  gap: 15px;
  padding: 15px;
  background-color: #e3f2fd;
  border-radius: 8px;
  margin-top: 20px;
}

.info-icon {
  color: #1976d2;
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.info-text {
  flex: 1;
  color: #0d47a1;
}

.info-text strong {
  display: block;
  margin-bottom: 8px;
}

.info-text ul {
  margin: 0;
  padding-left: 20px;
}

.info-text li {
  margin: 5px 0;
  font-size: 14px;
}

mat-dialog-actions {
  padding: 16px 0;
  margin-top: 20px;
}

.button-spinner {
  display: inline-block;
  margin-right: 8px;
}

/* Snackbar styles */
::ng-deep .success-snackbar {
  background-color: #4caf50 !important;
  color: white !important;
}

::ng-deep .error-snackbar {
  background-color: #f44336 !important;
  color: white !important;
}

::ng-deep .warning-snackbar {
  background-color: #ff9800 !important;
  color: white !important;
}

/* Next Page button styles */
button.primary,
button.secondary {
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  min-width: 100px;
}

button.primary.small,
button.secondary.small {
  font-size: 13px;
  padding: 6px 12px;
  min-width: 80px;
}

button.primary {
  background-color: #0066cc;
  border-color: #0066cc;
  color: #ffffff;
}

button.primary:hover:not(:disabled) {
  background-color: #0052a3;
  border-color: #0052a3;
}

button.primary:active:not(:disabled) {
  background-color: #003d7a;
  border-color: #003d7a;
}

button.primary:disabled {
  background-color: #cccccc;
  border-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
  opacity: 0.6;
}

button.secondary {
  background-color: #ffffff;
  border-color: #0066cc;
  color: #0066cc;
}

button.secondary:hover:not(:disabled) {
  background-color: #f0f7ff;
  border-color: #0052a3;
  color: #0052a3;
}

button.secondary:active:not(:disabled) {
  background-color: #e0eeff;
  border-color: #003d7a;
  color: #003d7a;
}

button.secondary:disabled {
  background-color: #f5f5f5;
  border-color: #cccccc;
  color: #999999;
  cursor: not-allowed;
  opacity: 0.6;
}

button.btn-link {
  background: none;
  border: none;
  padding: 0;
  margin-left: 10px;
  cursor: pointer;
  font-size: 18px;
}

button.btn-link.text-danger {
  color: #f44336;
}

button.btn-link.text-danger:hover {
  color: #d32f2f;
}

`, "",{"version":3,"sources":["webpack://./projects/tilmanagement/src/app/turbines/bulk-upload/turbine-bulk-upload.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;;EAEE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".bulk-upload-dialog {\n  min-width: 500px;\n  max-width: 600px;\n}\n\n.upload-container {\n  padding: 20px 0;\n}\n\n.instructions {\n  color: #666;\n  margin-bottom: 20px;\n  line-height: 1.5;\n}\n\n.template-download-section {\n  margin: 15px 0;\n  text-align: center;\n}\n\n.template-download-btn {\n  min-width: 200px;\n}\n\n.file-upload-section {\n  margin: 20px 0;\n}\n\n.file-input-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding: 15px;\n  border: 2px dashed #ccc;\n  border-radius: 8px;\n  background-color: #f9f9f9;\n  transition: all 0.3s ease;\n}\n\n.file-input-wrapper:hover {\n  border-color: #3f51b5;\n  background-color: #f5f5f5;\n}\n\n.file-name {\n  flex: 1;\n  color: #333;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.no-file-selected {\n  color: #999;\n  font-style: italic;\n}\n\n.clear-file-btn {\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n}\n\n.clear-file-btn mat-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n  line-height: 18px;\n}\n\n.upload-progress {\n  margin: 20px 0;\n}\n\n.uploading-text {\n  text-align: center;\n  color: #ff6f00;\n  font-weight: 500;\n  margin-top: 10px;\n  font-size: 16px;\n}\n\n.info-section {\n  display: flex;\n  gap: 15px;\n  padding: 15px;\n  background-color: #e3f2fd;\n  border-radius: 8px;\n  margin-top: 20px;\n}\n\n.info-icon {\n  color: #1976d2;\n  font-size: 24px;\n  width: 24px;\n  height: 24px;\n}\n\n.info-text {\n  flex: 1;\n  color: #0d47a1;\n}\n\n.info-text strong {\n  display: block;\n  margin-bottom: 8px;\n}\n\n.info-text ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.info-text li {\n  margin: 5px 0;\n  font-size: 14px;\n}\n\nmat-dialog-actions {\n  padding: 16px 0;\n  margin-top: 20px;\n}\n\n.button-spinner {\n  display: inline-block;\n  margin-right: 8px;\n}\n\n/* Snackbar styles */\n::ng-deep .success-snackbar {\n  background-color: #4caf50 !important;\n  color: white !important;\n}\n\n::ng-deep .error-snackbar {\n  background-color: #f44336 !important;\n  color: white !important;\n}\n\n::ng-deep .warning-snackbar {\n  background-color: #ff9800 !important;\n  color: white !important;\n}\n\n/* Next Page button styles */\nbutton.primary,\nbutton.secondary {\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.5;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  min-width: 100px;\n}\n\nbutton.primary.small,\nbutton.secondary.small {\n  font-size: 13px;\n  padding: 6px 12px;\n  min-width: 80px;\n}\n\nbutton.primary {\n  background-color: #0066cc;\n  border-color: #0066cc;\n  color: #ffffff;\n}\n\nbutton.primary:hover:not(:disabled) {\n  background-color: #0052a3;\n  border-color: #0052a3;\n}\n\nbutton.primary:active:not(:disabled) {\n  background-color: #003d7a;\n  border-color: #003d7a;\n}\n\nbutton.primary:disabled {\n  background-color: #cccccc;\n  border-color: #cccccc;\n  color: #666666;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\nbutton.secondary {\n  background-color: #ffffff;\n  border-color: #0066cc;\n  color: #0066cc;\n}\n\nbutton.secondary:hover:not(:disabled) {\n  background-color: #f0f7ff;\n  border-color: #0052a3;\n  color: #0052a3;\n}\n\nbutton.secondary:active:not(:disabled) {\n  background-color: #e0eeff;\n  border-color: #003d7a;\n  color: #003d7a;\n}\n\nbutton.secondary:disabled {\n  background-color: #f5f5f5;\n  border-color: #cccccc;\n  color: #999999;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\nbutton.btn-link {\n  background: none;\n  border: none;\n  padding: 0;\n  margin-left: 10px;\n  cursor: pointer;\n  font-size: 18px;\n}\n\nbutton.btn-link.text-danger {\n  color: #f44336;\n}\n\nbutton.btn-link.text-danger:hover {\n  color: #d32f2f;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
